// /settings/protocols/new — мастер подключения протокола (010, T017; FR-004; макеты 4 – 7):
// страница раздела «Протоколы», не вложенная в список. Право — templates.write. ?template=<id> —
// «Изменить карту» схемы (FR-034). Крошки: «Настройки / Протоколы / Подключить протокол».
import { createFileRoute } from '@tanstack/react-router';
import { OnboardingPage } from '../../../features/protocols/OnboardingPage.tsx';
import { parseOnboardingSearch } from '../../../features/protocols/search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/settings/protocols_/new')({
  validateSearch: parseOnboardingSearch,
  beforeLoad: requireSection('protocolOnboarding'),
  staticData: { crumb: 'Подключить протокол' },
  component: OnboardingRoute,
});

function OnboardingRoute() {
  const { template } = Route.useSearch();
  // Другая схема — новый мастер: ответы прежнего не переносятся.
  return <OnboardingPage key={template ?? 'new'} {...(template ? { templateId: template } : {})} />;
}
